import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, createApi, FetchArgs } from '@reduxjs/toolkit/dist/query/react';
import { auth, logout } from '@/store/features/auth.slice';
import { storageLocal } from '@/utils/storage.utils';

const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000';
const API_KEY = import.meta.env.VITE_API_KEY || '';

const getToken = () => {
  // TODO read token from cookies or url parameters (for verify and reset)
  return storageLocal.getItem('accessToken');
};

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  //credentials: 'include',
  //credentials: 'same-origin',
  prepareHeaders: (headers) => {
    headers.set('ApiKey', `${API_KEY}`);
    const authToken = getToken();
    if (authToken) {
      headers.set('Authorization', 'Bearer ' + authToken);
    }
    return headers;
  },
}) as unknown as BaseQueryFn<
  string | FetchArgs,
  unknown,
  { status: number; message: string | string[]; error: string }
>;

const baseQueryWithHeaders: BaseQueryFn<
  string | FetchArgs,
  unknown,
  {
    status: number;
    message: string | string[];
    error: string;
  }
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  // if access is expired
  if (result.error && result.error.status === 401) {
    const refreshToken = storageLocal.getItem('refreshToken');
    if (refreshToken) {
      storageLocal.setItem('accessToken', refreshToken);
      const refreshResult = await baseQuery(
        {
          url: '/auth/refresh',
          method: 'POST',
        },
        api,
        extraOptions,
      );
      if (refreshResult.data) {
        api.dispatch(auth(refreshResult.data));
        // retry the initial query
        result = await baseQuery(args, api, extraOptions);
      } else {
        storageLocal.removeItem('accessToken');
        api.dispatch(logout());
        // document.location = '/login';
      }
    }
  }
  return result;
};

const baseApi = createApi({
  baseQuery: baseQueryWithHeaders,
  endpoints: () => ({}),
});

export { API_URL, baseApi };
